import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const VersionedAgentSchema = z.object({
  _id: zExt.objectId(),
  createdAt: z.date(),
  name: z.string(),
  prompt: z.string(),
  version: z.number().nullish(),
  publishedAt: z.date().nullish(),
});

export type VersionedAgent = z.infer<typeof VersionedAgentSchema>;
